// Data structure for KSB section
// Image paths follow convention: /assets/ksb/{category}/{filename}

export const ksbData = {
  // Main KSB landing page
  ksb: {
    slug: '/ksb',
    breadcrumb: 'KSB',
    title: 'KSB',
    intro: [
      'KSB es una empresa líder mundial en la fabricación de bombas, válvulas y sistemas de control.',
      'Sus productos se aplican en los sectores de agua, saneamiento, industria, building, energía y centrales térmicas y eléctricas, ofreciendo alto rendimiento, eficiencia energética y una larga vida útil.'
    ],
    sections: [
      {
        heading: null,
        cards: [
          {
            title: 'Bombas',
            description: 'Equipos para impulsión, transporte y manejo de fluidos industriales, redes de agua y sistemas de energía.',
            imageKey: 'ksb-bombas',
            image: '/assets/ksb/aguas-efluentes/IMG_3846.webp',
            href: '/ksb/bombas'
          },
          {
            title: 'Válvulas',
            description: 'Válvulas industriales diseñadas para regular, aislar y proteger el paso de fluidos en sistemas de agua y procesos productivos.',
            imageKey: 'ksb-valvulas',
            image: '/assets/ksb/valvulas/IMG_2580.webp',
            href: '/ksb/valvulas'
          },
          {
            title: 'Sistemas de presurización (Hyamat)',
            description: 'Equipos automáticos que mantienen presión constante en redes de agua con control inteligente y alta eficiencia.',
            imageKey: 'ksb-hyamat',
            image: '/assets/ksb/presurizacion/IMG_3503.webp',
            href: '/ksb/presurizacion'
          },
          {
            title: 'Monitoreo (KSB Guard)',
            description: 'Sensores que monitorean bombas en tiempo real y alertan fallas para evitar paradas inesperadas.',
            imageKey: 'ksb-guard',
            image: '/assets/ksb/guard-cover.webp',
            svgType: 'monitor',
            href: '/assets/ksb/KSB Guard - Monitoreo.pdf',
            isPdfModal: true
          },
          {
            title: 'Service, puesta en marcha y asesoramiento',
            description: 'Soporte técnico para instalación, arranque y mantenimiento de equipos industriales.',
            imageKey: 'ksb-service',
            image: '/assets/ksb/service/IMG_0996.JPG',
            href: '/ksb/service'
          }
        ]
      }
    ]
  },

  // Bombas page
  'bombas': {
    slug: '/ksb/bombas',
    breadcrumb: 'Bombas',
    title: 'Bombas',
    intro: [],
    sections: [
      {
        heading: null,
        cards: [
          {
            title: 'Aguas y efluentes',
            description: 'Soluciones confiables para el manejo, impulsión y tratamiento de aguas limpias y residuales.',
            imageKey: 'ksb-aguas-efluentes',
            image: '/assets/ksb/aguas-efluentes/IMG_3846.webp',
            href: '/ksb/bombas/aguas-efluentes'
          },
          {
            title: 'Defensa contra inundaciones',
            description: 'Equipos de gran caudal diseñados para estaciones de bombeo y protección hídrica urbana o industrial.',
            imageKey: 'ksb-inundaciones',
            image: '/assets/ksb/defensa-inundaciones/IMG_9523.JPG',
            href: '/ksb/bombas/defensa-inundaciones'
          },
          {
            title: 'Centrales térmicas / eléctricas',
            description: 'Bombas de proceso y servicios auxiliares para plantas de generación eléctrica y cogeneración.',
            imageKey: 'ksb-centrales',
            image: '/assets/ksb/centrales-electricas/IMG_6289.JPG',
            href: '/ksb/bombas/centrales-termicas'
          },
          {
            title: 'Industrias',
            description: 'Aplicaciones adaptadas a procesos industriales exigentes: alimentos, químicos, papel, minería y más.',
            imageKey: 'ksb-industrias',
            image: '/assets/ksb/industria/17BA700B-6EA4-4086-90DD-F43CF01325D7.JPG',
            href: '/ksb/bombas/industrias'
          },
          {
            title: 'Sistemas contra incendios',
            description: 'Bombas certificadas para redes contraincendio, conforme a normativas NFPA y estándares internacionales.',
            imageKey: 'ksb-incendios',
            image: '/assets/ksb/incendio/IMG_3287.JPG',
            href: '/ksb/bombas/sistemas-incendios'
          },
          {
            title: 'Building',
            description: 'Bombas para aplicaciones en edificios y desarrollos de infraestructura.',
            imageKey: 'ksb-building',
            image: '/assets/ksb/building/IMG_3503.webp',
            href: '/ksb/bombas/building'
          }
        ]
      }
    ],
    ctaText: 'Representamos tecnología que potencia la eficiencia y confiabilidad de tus procesos.'
  },

  // Válvulas page
  'valvulas': {
    slug: '/ksb/valvulas',
    breadcrumb: 'Válvulas',
    title: 'Válvulas',
    intro: [
      'KSB ofrece una amplia gama de válvulas industriales diseñadas para regular, aislar y proteger el paso de fluidos en sistemas de agua, procesos industriales y aplicaciones energéticas.',
      'Fabricadas con materiales de alta resistencia y tecnología de precisión, garantizan un funcionamiento seguro, baja pérdida de carga y larga vida útil incluso en condiciones exigentes.'
    ],
    sections: [
      {
        heading: null,
        cards: [
          {
            title: 'Válvulas',
            description: 'Válvulas industriales diseñadas para regular, aislar y proteger sistemas de agua, procesos industriales y aplicaciones energéticas con máxima eficiencia hidráulica.',
            imageKey: 'ksb-valvulas-industrial',
            image: '/assets/ksb/valvulas/IMG_2580.webp',
            href: '/ksb/valvulas/productos'
          },
          {
            title: 'Stock de válvulas',
            description: 'Stock de válvulas disponibles en fábrica KSB Argentina.',
            imageKey: 'ksb-stock-valvulas',
            image: '/assets/ksb/valvulas-stock/IMG_1945.webp',
            href: '/ksb/valvulas/stock'
          }
        ]
      }
    ],
    ctaText: 'Representamos tecnología que potencia la eficiencia y confiabilidad de tus procesos.'
  }
};

// Equipment/subpage details for individual KSB pages
export const ksbEquipmentData = {
  // Bombas subpages
  'bombas/catalogo': {
    slug: '/ksb/bombas/catalogo',
    breadcrumb: 'Catálogo de bombas',
    title: 'Catálogo de bombas',
    category: 'bombas',
    categoryTitle: 'Bombas',
    description: 'Descargá el catálogo técnico completo con curvas, materiales y especificaciones de cada modelo.',
    images: []
  },
  'bombas/aguas-efluentes': {
    slug: '/ksb/bombas/aguas-efluentes',
    breadcrumb: 'Aguas y efluentes',
    title: 'Aguas y efluentes',
    category: 'bombas',
    categoryTitle: 'Bombas',
    description: 'Sistemas de bombeo KSB implementados en acueductos, plantas potabilizadoras y redes de distribución de agua.',
    referencesHeading: 'Referencias de Meyle SRL',
    images: [
      '/assets/ksb/aguas-efluentes/328bd827-3308-4ede-b246-daabb5d7e1f4.webp',
      '/assets/ksb/aguas-efluentes/042f7199-7926-4cc7-81a9-e4534d3ae412.webp',
      '/assets/ksb/aguas-efluentes/f719f4d5-4388-42c4-ae42-874180bf014f.webp',
      '/assets/ksb/aguas-efluentes/ddfc8bb6-df25-4b3e-bc0d-e76263023607.webp',
      '/assets/ksb/aguas-efluentes/1d40618f-cf1d-4b89-81e8-88bbcd26f345.webp',
      '/assets/ksb/aguas-efluentes/DSCN6978.webp',
      '/assets/ksb/aguas-efluentes/IMG_3157.webp',
      '/assets/ksb/aguas-efluentes/IMG_3800.webp',
      '/assets/ksb/aguas-efluentes/IMG_3826.webp',
      '/assets/ksb/aguas-efluentes/IMG_3846.webp',
      '/assets/ksb/aguas-efluentes/IMG_3855.webp',
      '/assets/ksb/aguas-efluentes/IMG_3866.webp',
      '/assets/ksb/aguas-efluentes/IMG_2550.webp',
      '/assets/ksb/aguas-efluentes/IMG_2553.webp',
      '/assets/ksb/aguas-efluentes/IMG_2577.webp',
      '/assets/ksb/aguas-efluentes/IMG_2595.webp',
      '/assets/ksb/aguas-efluentes/IMG_2599.webp',
      '/assets/ksb/aguas-efluentes/IMG_2611.webp',
      '/assets/ksb/aguas-efluentes/IMG_2612.webp',
      '/assets/ksb/aguas-efluentes/IMG_2628.webp',
      '/assets/ksb/aguas-efluentes/IMG_2688.JPG',
      '/assets/ksb/aguas-efluentes/IMG_7378.JPG',
      '/assets/ksb/aguas-efluentes/IMG_7382.JPG',
      '/assets/ksb/aguas-efluentes/IMG_7388.JPG',
      '/assets/ksb/aguas-efluentes/IMG_7402.JPG',
      '/assets/ksb/aguas-efluentes/IMG_7489.JPG',
      '/assets/ksb/aguas-efluentes/IMG_7540.JPG',
      '/assets/ksb/aguas-efluentes/IMG_7571.JPG',
      '/assets/ksb/aguas-efluentes/IMG_7595.JPG',
      '/assets/ksb/aguas-efluentes/IMG_7601.JPG',
      '/assets/ksb/aguas-efluentes/IMG_7611.JPG',
      '/assets/ksb/aguas-efluentes/IMG_7640.JPG',
      '/assets/ksb/aguas-efluentes/IMG_8483.JPG',
      '/assets/ksb/aguas-efluentes/IMG_8485.JPG',
      '/assets/ksb/aguas-efluentes/IMG_8497.JPG',
      '/assets/ksb/aguas-efluentes/IMG_8988.webp',
      '/assets/ksb/aguas-efluentes/IMG_8991.webp',
      '/assets/ksb/aguas-efluentes/IMG_9009.webp',
      '/assets/ksb/aguas-efluentes/IMG_9010.webp',
      '/assets/ksb/aguas-efluentes/IMG_9012.webp',
      '/assets/ksb/aguas-efluentes/IMG_9013.webp',
      '/assets/ksb/aguas-efluentes/IMG_9017.webp',
      '/assets/ksb/aguas-efluentes/IMG_9018.webp',
      '/assets/ksb/aguas-efluentes/IMG_9027.webp'
    ]
  },
  'bombas/defensa-inundaciones': {
    slug: '/ksb/bombas/defensa-inundaciones',
    breadcrumb: 'Defensa contra inundaciones',
    title: 'Defensa contra inundaciones',
    category: 'bombas',
    categoryTitle: 'Bombas',
    description: 'Equipos de bombeo de gran caudal diseñados para el control y drenaje en situaciones de emergencia por inundaciones.',
    referencesHeading: 'Referencias de Meyle SRL',
    images: [
      '/assets/ksb/defensa-inundaciones/IMG_9523.JPG',
      '/assets/ksb/defensa-inundaciones/IMG_9526.JPG',
      '/assets/ksb/defensa-inundaciones/IMG_0517.JPG',
      '/assets/ksb/defensa-inundaciones/IMG_9538.JPG',
      '/assets/ksb/defensa-inundaciones/IMG_6901.JPG',
      '/assets/ksb/defensa-inundaciones/IMG_6407.webp'
    ]
  },
  'bombas/centrales-termicas': {
    slug: '/ksb/bombas/centrales-termicas',
    breadcrumb: 'Centrales térmicas / eléctricas',
    title: 'Centrales térmicas / eléctricas',
    category: 'bombas',
    categoryTitle: 'Bombas',
    description: 'Soluciones KSB para circulación, refrigeración y control de procesos en plantas termoeléctricas e hidroeléctricas.',
    referencesHeading: 'Referencias de Meyle SRL',
    images: [
      '/assets/ksb/centrales-electricas/IMG_6289.JPG',
      '/assets/ksb/centrales-electricas/IMG_3763.webp',
      '/assets/ksb/centrales-electricas/IMG_3759.webp',
      '/assets/ksb/centrales-electricas/IMG_7185.JPG',
      '/assets/ksb/centrales-electricas/IMG_3754.webp',
      '/assets/ksb/centrales-electricas/HPIM1289.webp',
      '/assets/ksb/centrales-electricas/IMG_3765.webp',
      '/assets/ksb/centrales-electricas/IMG_0448.JPG',
      '/assets/ksb/centrales-electricas/IM000072.webp',
      '/assets/ksb/centrales-electricas/IMG_5599.webp',
      '/assets/ksb/centrales-electricas/720A895E-CA60-4FCA-8AF9-80567D90D284.JPG',
      '/assets/ksb/centrales-electricas/IMG_5596.webp',
      '/assets/ksb/centrales-electricas/IMG_5597.webp',
      '/assets/ksb/centrales-electricas/IMG_6227.JPG',
      '/assets/ksb/centrales-electricas/IMG_3413.JPG',
      '/assets/ksb/centrales-electricas/IMG_6484.JPG',
      '/assets/ksb/centrales-electricas/IMG_8287.JPG',
      '/assets/ksb/centrales-electricas/IMG_8309.JPG',
      '/assets/ksb/centrales-electricas/0a59b542-0a94-4013-9ae2-a79347f043d6.webp',
      '/assets/ksb/centrales-electricas/IMG_2237.JPG',
      '/assets/ksb/centrales-electricas/IMG_2342.webp'
    ]
  },
  'bombas/industrias': {
    slug: '/ksb/bombas/industrias',
    breadcrumb: 'Industrias',
    title: 'Industrias',
    category: 'bombas',
    categoryTitle: 'Bombas',
    description: 'Aplicaciones adaptadas a procesos industriales exigentes: alimentos, químicos, papel, minería y más.',
    referencesHeading: 'Referencias de Meyle SRL',
    images: [
      '/assets/ksb/industria/6107D9F4-EB34-4C24-8AB8-A3A8C5623A87.JPG',
      '/assets/ksb/industria/17BA700B-6EA4-4086-90DD-F43CF01325D7.JPG',
      '/assets/ksb/industria/IMG_0558.JPG',
      '/assets/ksb/industria/CE4FF3D8-20F9-49ED-BCF0-82885187C396.JPG',
      '/assets/ksb/industria/IMG_1243.JPG',
      '/assets/ksb/industria/IMG_4090.webp',
      '/assets/ksb/industria/IMG_0562.JPG',
      '/assets/ksb/industria/IMG_7185.JPG',
      '/assets/ksb/industria/211D5F78-04DB-4C21-91EF-53FA4FD6EAA7.JPG',
      '/assets/ksb/industria/IMG_4059.webp',
      '/assets/ksb/industria/IMG_6407.JPG',
      '/assets/ksb/industria/11CFDD80-37F4-4402-83A6-6A7AF34069D4.JPG',
      '/assets/ksb/industria/IMG_4079.webp',
      '/assets/ksb/industria/916807C9-ACAE-4C24-A33E-D6CFEB38E8A6.JPG',
      '/assets/ksb/industria/cc4193f2-740a-4f19-b07f-e28443b84116.webp',
      '/assets/ksb/industria/IMG_3524.webp',
      '/assets/ksb/industria/IMG_5488.webp',
      '/assets/ksb/industria/IMG_3747.webp',
      '/assets/ksb/industria/B4C32B38-3A2A-4892-8BFF-0A8217A1E483.JPG',
      '/assets/ksb/industria/IMG_3195.webp',
      '/assets/ksb/industria/EF6335FD-6029-44CA-9C4C-9AEC4996FEA1.JPG',
      '/assets/ksb/industria/IMG_5503.webp',
      '/assets/ksb/industria/IMG_8595.webp',
      '/assets/ksb/industria/IMG_2392.webp',
      '/assets/ksb/industria/IMG_9563.JPG',
      '/assets/ksb/industria/4B634859-B951-41FD-933E-ACDE09471157.JPG',
      '/assets/ksb/industria/IMG_9567.JPG',
      '/assets/ksb/industria/IMG_8618.webp',
      '/assets/ksb/industria/39A1B52E-F020-43C7-A80F-9BECCB621B9E.JPG',
      '/assets/ksb/industria/IMG_3500.webp',
      '/assets/ksb/industria/IMG_5505.webp',
      '/assets/ksb/industria/IMG_3501.webp'
    ]
  },
  'bombas/sistemas-incendios': {
    slug: '/ksb/bombas/sistemas-incendios',
    breadcrumb: 'Sistemas contra incendios',
    title: 'Sistemas contra incendios',
    category: 'bombas',
    categoryTitle: 'Bombas',
    description: 'Bombas y sistemas de presurización certificados para protección en plantas industriales y edificios.',
    referencesHeading: 'Referencias de Meyle SRL',
    images: [
      '/assets/ksb/incendio/IMG_3287.JPG',
      '/assets/ksb/incendio/IMG_6408.webp',
      '/assets/ksb/incendio/IMG_9783.JPG',
      '/assets/ksb/incendio/IMG_3650.webp',
      '/assets/ksb/incendio/211D5F78-04DB-4C21-91EF-53FA4FD6EAA7.JPG',
      '/assets/ksb/incendio/6107D9F4-EB34-4C24-8AB8-A3A8C5623A87.JPG',
      '/assets/ksb/incendio/IMG_2973.webp',
      '/assets/ksb/incendio/IMG_2699.webp',
      '/assets/ksb/incendio/IMG_4006.JPG',
      '/assets/ksb/incendio/IMG_2944.webp',
      '/assets/ksb/incendio/E39BDE5D-42B5-474C-B650-2C48E63913D6.JPG',
      '/assets/ksb/incendio/IMG_5921.webp',
      '/assets/ksb/incendio/IMG_0725.JPG',
      '/assets/ksb/incendio/IMG_2697.webp',
      '/assets/ksb/incendio/IMG_4008.JPG',
      '/assets/ksb/incendio/IMG_5923.webp',
      '/assets/ksb/incendio/11AB3EF0-ECB3-467F-95C5-057313D3932B.JPG',
      '/assets/ksb/incendio/3F2ECBE8-491E-4DFA-B97B-8A3C37D231FB.JPG',
      '/assets/ksb/incendio/IMG_3266.JPG',
      '/assets/ksb/incendio/IMG_6410.webp',
      '/assets/ksb/incendio/IMG_3070.JPG',
      '/assets/ksb/incendio/IMG_3067.JPG',
      '/assets/ksb/incendio/Dscn0994.webp',
      '/assets/ksb/incendio/IMG_5924.webp',
      '/assets/ksb/incendio/Dscn0984.webp',
      '/assets/ksb/incendio/IMG_3314.JPG',
      '/assets/ksb/incendio/IMG_1112.JPG',
      '/assets/ksb/incendio/IMG_3648.webp',
      '/assets/ksb/incendio/IMG_3276.JPG',
      '/assets/ksb/incendio/IMG_3289.JPG'
    ]
  },
  'bombas/building': {
    slug: '/ksb/bombas/building',
    breadcrumb: 'Building',
    title: 'Building',
    category: 'bombas',
    categoryTitle: 'Bombas',
    description: 'Bombas para aplicaciones en edificios y desarrollos de infraestructura.',
    referencesHeading: 'Referencias de Meyle SRL',
    images: [
      '/assets/ksb/building/IMG_3503.webp',
      '/assets/ksb/building/IMG_7371.webp',
      '/assets/ksb/building/IMG_2942.webp',
      '/assets/ksb/building/IMG_3502.webp',
      '/assets/ksb/building/IMG_3499.webp',
      '/assets/ksb/building/IMG_2986.webp',
      '/assets/ksb/building/IMG_3504.webp',
      '/assets/ksb/building/IMG_2985.webp',
      '/assets/ksb/building/IMG_3501.webp',
      '/assets/ksb/building/IMG_7372.webp',
      '/assets/ksb/building/IMG_7365.webp',
      '/assets/ksb/building/IMG_7373.webp',
      '/assets/ksb/building/IMG_7369.webp'
    ]
  },

  // Válvulas subpages
  'valvulas/catalogo': {
    slug: '/ksb/valvulas/catalogo',
    breadcrumb: 'Catálogo de válvulas',
    title: 'Catálogo de válvulas',
    category: 'valvulas',
    categoryTitle: 'Válvulas',
    description: 'Accedé a la documentación completa de válvulas KSB con modelos, materiales, curvas de desempeño y todas las especificaciones técnicas para cada aplicación.',
    images: []
  },
  'valvulas/productos': {
    slug: '/ksb/valvulas/productos',
    breadcrumb: 'Válvulas',
    title: 'Válvulas',
    category: 'valvulas',
    categoryTitle: 'Válvulas',
    description: 'Válvulas industriales diseñadas para regular, aislar y proteger sistemas de agua, procesos industriales y aplicaciones energéticas con máxima eficiencia hidráulica.',
    referencesHeading: 'Referencias de Meyle SRL',
    images: [
      '/assets/ksb/valvulas/IMG_2580.webp',
      '/assets/ksb/valvulas/IMG_8990.webp',
      '/assets/ksb/valvulas/IMG_8991.webp',
      '/assets/ksb/valvulas/IMG_9017.webp',
      '/assets/ksb/valvulas/IMG_8535.JPG',
      '/assets/ksb/valvulas/IMG_8537.JPG',
      '/assets/ksb/valvulas/IMG_9012.webp',
      '/assets/ksb/valvulas/IMG_9009.webp',
      '/assets/ksb/valvulas/IMG_2565.webp',
      '/assets/ksb/valvulas/IMG_9221.webp',
      '/assets/ksb/valvulas/IMG_2585.webp',
      '/assets/ksb/valvulas/IMG_8989.webp',
      '/assets/ksb/valvulas/IMG_2567.webp'
    ]
  },
  'valvulas/stock': {
    slug: '/ksb/valvulas/stock',
    breadcrumb: 'Stock de válvulas',
    title: 'Stock de válvulas',
    category: 'valvulas',
    categoryTitle: 'Válvulas',
    description: 'Stock de válvulas disponibles en fábrica KSB Argentina.',
    referencesHeading: 'Referencias de Meyle SRL',
    images: [
      '/assets/ksb/valvulas-stock/IMG_1945.webp',
      '/assets/ksb/valvulas-stock/IMG_6389.webp',
      '/assets/ksb/valvulas-stock/IMG_6385.webp',
      '/assets/ksb/valvulas-stock/IMG_1944.webp',
      '/assets/ksb/valvulas-stock/IMG_6393.webp',
      '/assets/ksb/valvulas-stock/IMG_1627.webp',
      '/assets/ksb/valvulas-stock/IMG_2969.webp',
      '/assets/ksb/valvulas-stock/IMG_6382.webp',
      '/assets/ksb/valvulas-stock/IMG_6383.webp',
      '/assets/ksb/valvulas-stock/IMG_2968.webp',
      '/assets/ksb/valvulas-stock/IMG_1626.webp',
      '/assets/ksb/valvulas-stock/IMG_6379.webp',
      '/assets/ksb/valvulas-stock/IMG_7354.webp',
      '/assets/ksb/valvulas-stock/IMG_1940.webp',
      '/assets/ksb/valvulas-stock/IMG_6381.webp',
      '/assets/ksb/valvulas-stock/IMG_6386.webp',
      '/assets/ksb/valvulas-stock/IMG_1593.webp',
      '/assets/ksb/valvulas-stock/IMG_6391.webp',
      '/assets/ksb/valvulas-stock/IMG_6387.webp'
    ]
  },

  // Presurización page
  'presurizacion': {
    slug: '/ksb/presurizacion',
    breadcrumb: 'Sistemas de presurización',
    title: 'Sistemas de presurización (Hyamat)',
    category: 'ksb',
    categoryTitle: 'KSB',
    description: 'Equipos automáticos que mantienen presión constante en redes de agua con control inteligente y alta eficiencia.',
    referencesHeading: 'Referencias de Meyle SRL',
    pdfHref: '/assets/ksb/KSB Hyamat - Sistemas de Presurización.pdf',
    images: [
      '/assets/ksb/presurizacion/IMG_3503.webp',
      '/assets/ksb/presurizacion/IMG_2942.webp',
      '/assets/ksb/presurizacion/IMG_2986.webp',
      '/assets/ksb/presurizacion/IMG_3501.webp',
      '/assets/ksb/presurizacion/IMG_7372.webp',
      '/assets/ksb/presurizacion/IMG_7365.webp',
      '/assets/ksb/presurizacion/IMG_7369.webp'
    ]
  },

  // Service page
  'service': {
    slug: '/ksb/service',
    breadcrumb: 'Service',
    title: 'Service, puesta en marcha y asesoramiento',
    category: 'ksb',
    categoryTitle: 'KSB',
    description: 'Soporte técnico para instalación, arranque y mantenimiento de equipos industriales.',
    referencesHeading: 'Referencias de Meyle SRL',
    images: [
      '/assets/ksb/service/IMG_0996.JPG',
      '/assets/ksb/service/IMG_6459.webp',
      '/assets/ksb/service/IMG_6289.JPG',
      '/assets/ksb/service/IMG_6305.JPG',
      '/assets/ksb/service/IMG_0562.JPG',
      '/assets/ksb/service/IMG_7185.JPG',
      '/assets/ksb/service/IMG_6448.JPG',
      '/assets/ksb/service/IMG_4059.webp',
      '/assets/ksb/service/5F847EAA-6B92-498F-A299-48D1A97052B0.JPG',
      '/assets/ksb/service/54944981-4D5B-449D-A0AC-C567BC1A9FE6.JPG',
      '/assets/ksb/service/CC0086B3-AB96-4941-8E01-BA3CBC57EEBF.JPG',
      '/assets/ksb/service/IMG_4079.webp',
      '/assets/ksb/service/9951B6FB-BD61-4CE4-B536-3EEFD8B9D781.JPG',
      '/assets/ksb/service/IMG_3528.webp',
      '/assets/ksb/service/IMG_0448.JPG',
      '/assets/ksb/service/IMG_0925.JPG',
      '/assets/ksb/service/IMG_1016.JPG',
      '/assets/ksb/service/IMG_0889.JPG',
      '/assets/ksb/service/IMG_4030.JPG',
      '/assets/ksb/service/HPIM0116.webp',
      '/assets/ksb/service/IMG_6219.JPG',
      '/assets/ksb/service/IMG_8284.JPG',
      '/assets/ksb/service/IMG_1195.webp',
      '/assets/ksb/service/IMG_8309.JPG',
      '/assets/ksb/service/39A1B52E-F020-43C7-A80F-9BECCB621B9E.JPG',
      '/assets/ksb/service/0a59b542-0a94-4013-9ae2-a79347f043d6.webp',
      '/assets/ksb/service/IMG_6407.webp',
      '/assets/ksb/service/IMG_2342.webp'
    ]
  }
};

export default ksbData;
